/**
 * Portal feature switches: typing-center defaults and per-client overrides
 * (contract: thaklis-doc 14-portal/PORTAL-EMPLOYEES-AND-FEATURES.md §5, PF2–PF5).
 */

import ApiService from '../api.service';
import { unwrapData } from '../../utils/apiConvert';
import { overridesFromOrg, defaultOn, FEATURE_KEYS } from './portalFeatures';

export const portalFeaturesService = {
  // TC defaults → { EMPLOYEES: true, … } (missing = on)
  getDefaults: async () => unwrapData(await ApiService.get('/api/settings/portal-features'))?.defaults || {},
  saveDefaults: async (defaults) =>
    unwrapData(await ApiService.put('/api/settings/portal-features', { defaults }))?.defaults || defaults,

  // A client's overrides; the backend returns them on the client row (portalFeatureOverrides).
  overridesFor: (org) => overridesFromOrg(org),

  // Save one client's overrides on their own, so the rest of the client record is untouched.
  saveOverrides: async (orgId, overrides) =>
    unwrapData(await ApiService.put(`/api/internal-organizations/${orgId}/portal-features`, { overrides }))?.overrides || overrides,

  bulkSet: async (orgIds, feature, value) =>
    unwrapData(await ApiService.put('/api/internal-organizations/portal-features/bulk', { orgIds, feature, value })),
};

/**
 * What the signed-in portal user may use: the login payload `portalFeatures` (effective values, the
 * client-only gate already applied). A session from before the backend sent it falls back to today's flags.
 */
export const portalFeaturesForSession = (portalUser) => {
  let org = {};
  try { org = JSON.parse(localStorage.getItem('portalOrganization') || '{}') || {}; } catch (e) { org = {}; }

  const features = org.portalFeatures || {};
  const tracking = org.employeeTrackingEnabled !== undefined
    ? org.employeeTrackingEnabled === true
    : org.thaklisEnabled !== false;
  const docExpiryAllowed = (portalUser?.docExpiryEnabled ?? org.docExpiryEnabled) !== false;
  return {
    ...Object.fromEntries(FEATURE_KEYS.map((k) => [k, features[k] !== false])),
    EMPLOYEES: features.EMPLOYEES !== false && tracking,
    DOC_EXPIRY: features.DOC_EXPIRY !== false && docExpiryAllowed,
  };
};

export { defaultOn };
